import { LeadSource, LeadStatus, QuoteType } from "../../models/Lead";
import Tooltip from "../shared/Tooltip";

// export enum LeadStatus {
//   "Awaiting Contact",
//   "Scheduled",
//   "Cancelled",
//   "Reschedule",
//   "Collected",
//   "Awaiting Payment",
//   "Awaiting COD",
//   "Customer to Call Back",
//   "Completed",
//   "All",
// }


const getQuoteTypeLabel = (quoteType: QuoteType) => {
  switch (quoteType) {
    case QuoteType.Salvage:
      return "Salvage";
    case QuoteType.ScrapExport:
      return "ELV";
    case QuoteType.SmartPrice:
      return "ELV";
    default:
      return "";
  }
};

export default function LeadStatusCell({
  status,
  website,
  quoteType,
}: {
  status: LeadStatus;
  website?: LeadSource;
  quoteType?: QuoteType;
}) {
  var className = "rounded-full px-3 py-1 text-xs font-semibold ";
  switch (status) {
    case LeadStatus["Awaiting Contact"]:
      className += "bg-gray-100 text-gray-800";
      break;
    case LeadStatus.Scheduled:
      className += "bg-blue-100 text-blue-600";
      break;
    case LeadStatus.Cancelled:
      className += "bg-red-100 text-red-600";
      break;
    case LeadStatus.Reschedule:
      className += "bg-yellow-100 text-yellow-600";
      break;
    case LeadStatus.Collected:
      className += "bg-purple-100 text-purple-600";
      break;
    case LeadStatus["Awaiting Payment"]:
      className += "bg-pink-100 text-pink-600";
      break;
    case LeadStatus["Awaiting COD"]:
      className += "bg-indigo-100 text-indigo-600";
      break;
    case LeadStatus["Customer to Call Back"]:
      className += "bg-teal-100 text-teal-600";
      break;
    case LeadStatus.Completed:
      className += "bg-green-200 text-green-600";
      break;
    case LeadStatus.All:
      className += "bg-gray-300 text-gray-600";
      break;
    case LeadStatus["Call List"]:
      className += "bg-orange-100 text-orange-700";
      break;
    case LeadStatus.Allocated:
      className += "bg-emerald-200 text-emerald-700";
      break;
  }

  const showQuoteTypePill =
    quoteType !== undefined &&
    (website === LeadSource.SellAVehicle || website === LeadSource.Widget);

  return (
    <div className="flex flex-col justify-center items-center flex-1 text-nowrap gap-4">
      <span title="Lead Status">
        <Tooltip content={"Lead Status"}>
          <span className={className}>{LeadStatus[status]}</span>
        </Tooltip>
      </span>

      {showQuoteTypePill && (
        <span title="Quote Type">
          <Tooltip content={"Quote Type"}>
            <span className="rounded-full px-3 py-1 text-xs font-semibold bg-cyan-100 text-cyan-700">
              {getQuoteTypeLabel(quoteType)}
            </span>
          </Tooltip>
        </span>
      )}
    </div>
  );
};